<template src="./registration_excel.html"></template>
<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import optionData from '@/optionData/data'
import _ from 'lodash'
import flatten from 'flat'
import {ko} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import { format } from 'date-fns'
export const BtnSelect = Vue.extend({
  name : 'btnSelect',
  template: `
      <vs-button class="btnSmall" @click="btnClickedHandler()" color="success" type="filled">선택</vs-button>
    `,
  data(){
    return{
      title : ''
    }
  },
  created(){
    this.title = this.params.colDef.headerName
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export default {
    name: "registration_excel",
    data() {
      return {
        optionData: optionData ,

        role: 'licensor',
        
        state : 'verified', // 가입 상태 - 인증
        currency: null,
        payment_method: null,
        default_service_fee_kr: 15,                  // 한국 정산요율
        default_service_fee_other: 15,               // 해외 정산요율
        entity_tax_exemption: false,                // 면세
        roleOption: optionData.role,
        paymentOption : optionData.payment,
        currencyOption: optionData.currency,
        countryOption : optionData.country,
        languageOption : optionData.language,
        fileList: [],
        files: [],              // 파일 데이터
        dropbox_link : null, // 실제론 google drive 링크로 사용중
        metaType : 'link',
        fileUrl: `${process.env.VUE_APP_API_URL}/file`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('srAccessToken')}`,
          'Access-Control-Allow-Origin': '*',
        },
        ko : ko,
        selectLicensor : [],
        memberOption : optionData.memberKeyword,
        page: {
          pageSize : 10,
          currentPage: 1,                       // 현재 페이지
          totalPage: 0,                         // 총 페이지수cline_text : this.cline_text
        },
        selectGenre : [],
        genreOption : [],

        albumGenre:[] ,
        albumStatusOption : optionData.albumStatus,
        albumStatus : 'registration_complete',

        sourceOption : optionData.albumSource,
        source : 'direct',
        releaseOption: optionData.releaseType,
        release_type : null,
        youtubeCIDOption:optionData.youtubeCID,
        youtube_cid : 'none' ,
        youtube_sr : true,
        youtube_at : true,
        copyrightOption : optionData.copyrightType,
        copyright : 'new',
        
       
        transfer_date : null,
        transfer_name : null,
        
        
        country : null ,
        original_release_date : null,
        release_date : null,
        release_time : '12:00:00',
        desired_release_date : null,
        tags : [[]],
        tags_v2 : [],
        contractDuration : null,
        contract : {
          service_fee_other :null,
          service_fee_kr :null,
          territory : null,
          territory_exception : '',
          territory_exception_v2 : [],
          start_date : null,
          end_date : null,
        },
        feeEditMode : false,
      

        gridOptions :{ // 테이블 옵션
            onRowClicked: (event)=>{
                
            },
        },
        defaultColDef: {
            sortable: false,
            editable: false,
            resizable: true,
            suppressMenu: false,
            rowSelection:'single'
        },
        columnDefs: [
          {headerName: 'E-mail ID', field: 'email', filter: false,width: 220,},
          {headerName: '권리자명 (성 이름)', field: 'licensor.family_name', filter: false,width: 150,
            cellRenderer: (data) => {
              let fm = data.data.licensor.family_name ? data.data.licensor.family_name : '';
              let gm = data.data.licensor.given_name ? data.data.licensor.given_name : '' ;
              return fm +' '+ gm
          }},
          {headerName: '회사명', field: 'licensor.company', filter: false,width: 150,},
          
          {headerName: '정산화폐', field: 'licensor.currency', filter: false,width: 150,
            cellRenderer: (data) => {
              const type = {
                  'krw' : 'KRW',
                  'usd' : 'USD',
                  'eur' : 'EUR',
              }
              return type[data.value]
          }},
          {headerName: '사업자여부', field: 'licensor.entity', filter: false,width: 150, cellRenderer: (data) => {
              const type = {
                  'individual' : '개인',
                  'corporation' : '사업자',
              }
              return type[data.value]
          }},
          {headerName: '거주국가',  field: 'licensor.entity_address.country',  filter: false,width: 155,},
          {headerName: 'MIMS',  field: 'licensor.mims_account',  filter: false,width: 155,},
        ],

        // 라이센서 추가
        gridOptions5 :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          onGridReady: function (event) {
          },
          frameworkComponents : {
            btnSelect : BtnSelect
          }
        },
        columnDefsUser : [
          {headerName: '선택', field: 'id', filter: false,width: 100,
            cellRendererParams: {
              clicked: function(data) {
                this.context.componentParent.selectLicensorData(data)
                this.context.componentParent.closeModal('licensor')
              }
            },
            cellRenderer: 'btnSelect'
          },
          {headerName: 'E-mail ID', field: 'email', filter: false,width: 220,},
          {headerName: '권리자명 (성 이름)', field: 'licensor.family_name', filter: false,width: 150,
            cellRenderer: (data) => {
              let fm = data.data.licensor.family_name ? data.data.licensor.family_name : '';
              let gm = data.data.licensor.given_name ? data.data.licensor.given_name : '' ;
              return fm +' '+ gm
          }},
          {headerName: '회사명', field: 'licensor.company', filter: false,width: 150,},
          
          {headerName: '정산화폐', field: 'licensor.currency', filter: false,width: 150,
            cellRenderer: (data) => {
              const type = {
                  'krw' : 'KRW',
                  'usd' : 'USD',
                  'eur' : 'EUR',
              }
              return type[data.value]
          }},
          {headerName: '사업자여부', field: 'licensor.entity', filter: false,width: 150, cellRenderer: (data) => {
              const type = {
                  'individual' : '개인',
                  'corporation' : '사업자',
              }
              return type[data.value]
          }},
          {headerName: '거주국가',  field: 'licensor.entity_address.country',  filter: false,width: 155,},
          {headerName: 'MIMS',  field: 'licensor.mims_account',  filter: false,width: 155,},
        ],
        keywordType : {label:'권리자명', value:'_name'},
        licensorKeyword : '',
        userList: {
          listData: [],                 
          pageSize: 10,                 
          currentPage: 1,
          totalPage: 0,                
        },


        
        accept:"",
        extensions:'',
        multiple: false,
        directory: false,
        drop: true,
        dropDirectory: true,
        addIndex: false,
        thread: 3,
        
        uploadAuto: false,
      }
    },
     watch:{
      'userList.currentPage'(){
        this.getUserList()
      },
     'contractDuration'(num){ 
       if(num != '0' && this.contract.start_date){
         
         this.contract.end_date = this.fixDate(new Date(moment(this.contract.start_date).add('years',num) ))
         console.log(this.contract.end_date)
       }
      },
     'contract.start_date'(){
       if(this.contractDuration != '0' && this.contract.start_date){
         this.contract.end_date = this.fixDate(new Date(moment(this.contract.start_date).add('years',this.contractDuration) ))
       }
      },
      'copyright'(){
        this.transfer_date = null
        this.transfer_name = null
      },
      'metaType'(e){
        this.files = []
        this.dropbox_link = null
        if(e == 'file'){
          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs.upload.drop = true
              this.$forceUpdate();
            }, 300);
          })
        }
      },
      'contract.territory'(){
        this.territory_exception = null
      }
    },
    mounted(){
      
    },
    methods: {
      //Licensor 매칭
      selectLicensorData (data){
        this.trackList = [[]]
        this.selectArtist = []
        
        this.selectLicensor= [data]
        this.contract.service_fee_kr = this.selectLicensor[0].licensor.default_service_fee_kr
        this.contract.service_fee_other = this.selectLicensor[0].licensor.default_service_fee_other
      },
      openLicensor(){
        
        this.keywordType =  {label:'권리자명', value:'_name'},
        this.licensorKeyword = '',
        this.openModal('licensor');
        this.getUserList()
      },
      getUserList(){
        const option = {
          sort: 'created_at',
          sortorder: 'desc',
          role : 'licensor',
          page: this.userList.currentPage-1 ,
          limit: this.userList.pageSize
        }
        if(this.keywordType && this.keywordType !='') {
            option[this.keywordType.value] = this.licensorKeyword
        }
        this.$store.dispatch('GETUSER', option)
        .then(result =>{
            this.userList.listData  = result.items // 권리자 목록
            //페이지 수
            const remainder = parseInt(result.filtered % this.userList.pageSize) > 0? 1: 0
            this.userList.totalPage = parseInt(result.filtered /this.userList.pageSize) + remainder
        }).catch(error=>{
            const status = error.response.status
            switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
              break;
            }
        })
      },
      all_save(){
        this.closeModal('confirm')
        if(this.selectLicensor.length < 1) {
          this.alert({msg:'Licensor 매칭을 해주세요.'});
          return false
        }
        if(this.valCheck(this.contract.territory)){
          this.alert({msg:'발매 뮤직스토어를 선택해주세요.'});
          return false
        }
        if(this.valCheck(this.contract.start_date)){
          this.alert({msg:'계약 시작일을 선택해주세요.'});
          return false
        }
        if(this.valCheck(this.contract.start_date)){
          this.alert({msg:'계약 시작일을 선택해주세요.'});
          return false
        }
        if(this.valCheck(this.contract.service_fee_kr)){
          this.alert({msg:'정산요율을 확인해주세요.'});
          return false
        }
        if(this.valCheck(this.contract.service_fee_other)){
          this.alert({msg:'정산요율을 확인해주세요.'});
          return false
        }
        const params = {
          licensor_id : this.selectLicensor[0].licensor.id,
          source: this.source,
          state: this.albumStatus,
          copyright_type: this.copyright,
          // distributor: "Sound Republica, Inc.",
          // explicit: false,
          youtube_cid: this.youtube_cid,
          youtube_sr : this.youtube_sr,
          youtube_at : this.youtube_at,
          contract_start_date : this.contract.start_date,
          contract_end_date : this.contract.end_date,
          contract_territory : this.contract.territory,
          contract_service_fee_kr : this.contract.service_fee_kr,
          contract_service_fee_other : this.contract.service_fee_other,
          tags : this.tags,
          tags_v2 : this.tags_v2,
          release_time : this.release_time

        }
        if(!this.valCheck(this.release_date)){
          params['release_date'] = this.release_date
        }
        if (this.contract.territory == 'global' && this.contract.territory_exception) {
          params['contract_territory_exception'] = 'korea'
          params['contract_territory_exception_v2'] = ['korea']
        }else{
          delete params['contract_territory_exception']
          params['contract_territory_exception_v2'] = []
        }
        if(!this.valCheck(this.transfer_name)){
          params['transfer_company'] = this.transfer_name
        }
        if(!this.valCheck(this.transfer_date)){
          params['transfer_date'] = this.transfer_date
        }
        const payload = {
          licensor_id : params.licensor_id,
          
          params: params
        }
        if(this.metaType == 'file'){
          if(this.files.length == 0) {
            this.alert({msg: `파일(Excel)을 등록해주세요.`,})
            return false
          }else{
            payload['file'] =  this.files[0].file
          }
        }else{
          if(this.valCheck(this.dropbox_link)) {
            this.alert({msg: `Google Drive Link를 입력해주세요.`,})
            return false
          }else{
            payload.params['gdrive_link'] = this.dropbox_link
          }
        }
        
        

        this.$store.dispatch("POST_ALBUM_EXCEL", payload)
        .then(result =>{
          this.alert({msg:'앨범 등록 요청이 완료되었습니다. <br/> 작업이 완료되면 알림(slack)으로 전송 될 것입니다.'})
          this.$router.push({path: '/album'});
        }).catch(error =>{
          const errorCode = error.response.data.code
          switch(errorCode){
            case 56:
              this.alert({
                type: 'primary',
                message: `이미 등록된 회원입니다.`,
                icon: 'tim-icons icon-bell-55',
              })
              break;
            default:
              this.alert({
                msg: error.response.data.message,
              })
              break;
          }

        })
      },
      send_template(params){
             // 지급방법
      },
      objectCompare(targetObj , subObj2) {
        return targetObj.map(t_obj =>{
          return t_obj.id
        }).filter(t_obj =>{
          return !subObj2.map(s_obj =>{
                  return s_obj.id
                }).includes(t_obj)
        })
      },
      handleRemove(file, fileList){
        this.file = null
      },
      handleChange(file, fileList){
        this.file = file.raw
        this.fileList = []
        this.fileList.push(fileList[fileList.length-1])
      },
      closeOpen(modalNo){
        return new Promise(resolve =>{
          resolve(this.modals[modalNo] = false)
        })
      },
      setUserFee(){
        if(this.selectLicensor.length == 0){
          this.alert({msg : '라이센서 매칭을 진행해주세요.'})
          return false
        }
        this.contract.service_fee_kr = this.selectLicensor[0].licensor.default_service_fee_kr
        this.contract.service_fee_other = this.selectLicensor[0].licensor.default_service_fee_other
      }

     
    }
}
</script>

<style  lang="scss" scoped>


.el-upload-dragger {
  background: transparent !important;
  background-color: #000 !important;
}
.el-upload {
  width: 100%;
}

</style>